<div class="relative w-full h-64 overflow-hidden">
    <div #track class="flex flex-col"

         style="transform: translateY(0); transition: transform 0.7s ease-in-out;">
        <ng-container *ngFor="let tmpl of templates">
            <ng-container *ngTemplateOutlet="tmpl"></ng-container>
        </ng-container>
        <ng-container *ngFor="let tmpl of templates">
            <ng-container *ngTemplateOutlet="tmpl"></ng-container>
        </ng-container>
    </div>
</div>